import React, { createContext, useState, useCallback } from "react";
import UserService from "../services/UserService";

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUser = useCallback(async (id) => {
    setLoading(true);
    try {
      const data = await UserService.getUser(id);
      setUser(data);
      return data;
    } catch (error) {
      console.error("Error fetching user", error);
      // Drop the previous user so a failed load reads as "not found" rather
      // than leaving the last-viewed user on screen.
      setUser(null);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const patchUser = useCallback(async (id, payload) => {
    try {
      const data = await UserService.patchUser(id, payload);
      setUser(data);
      return data;
    } catch (error) {
      console.error("Error updating user", error);
      throw error;
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        fetchUser,
        patchUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
